import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { VehicleListingInterface } from "../interface/motor/motor-link.interface";

@Injectable({
	providedIn: "root"
})
export class MasterDataDataService {
	private basePath: string = `${environment.url}/api/MasterData/`;

	constructor(private http: HttpClient) {}

	getNcdList(): number[] {
		return [0, 0.15, 0.2, 0.25, 0.3, 0.3833, 0.45, 0.55];
	}

	getCommercialNcdList(): number[] {
		return [0, 0.15, 0.2, 0.25];
	}

	getMotorcycleNcdList(): number[] {
		return [0, 0.15, 0.2, 0.25];
	}

	getCountrySelection() {
		return this.http.get<string[]>(`${this.basePath}GetCountrySelection`);
	}

	getSelection() {
		return this.http.get<string[]>(`${this.basePath}GetCountrySelection`);
	}

	getInsuranceProviderSelection() {
		return this.http.get<{ id: string; name: string }[]>(
			`${this.basePath}GetInsuranceProviderSelection`
		);
	}

	getEmployeeCompanyStatusSelection() {
		return this.http.get<string[]>(
			`${this.basePath}GetEmployeeCompanyStatusSelection`
		);
	}

	getFileDocConditionList() {
		return this.http.get(`${this.basePath}GetFileDocConditionList`);
	}

	getShopeeClaimTypeSelection() {
		return this.http.get(`${this.basePath}GetShopeeClaimTypeSelection`);
	}

	getRejectReasonSelection() {
		return this.http.get(`${this.basePath}GetRejectReasonSelection`);
	}

	// For shopee AMS
	getAMSAssessmentTypeSelection() {
		return this.http.get(`${this.basePath}GetAMSAssessmentTypeSelection`);
	}

	getVehicleModelListing(
		limit: number,
		offset: number,
		text: string,
		columnIndex: number,
		sortDirection: string,
		make: string
	) {
		return this.http.post<VehicleListingInterface[]>(
			`${this.basePath}GetVehicleModelListing`,
			{
				limit,
				offset,
				text,
				columnIndex,
				sortDirection,
				make
			}
		);
	}

	selectAllPostcodes() {
		return this.http.get<string[]>(`${this.basePath}SelectAllPostcodes`);
	}
}
